import { Grid, InputAdornment, Typography } from "@mui/material";

import { AdornmentButton } from "components/GeneralStyled";
import NumberFormats from "components/NumberFormats";
import PriceInput from "components/PriceInput";
import { useFormContext } from "react-hook-form";

function TransferAmount({ selectedCoin, transferAmountMax }) {
  const { watch, setValue } = useFormContext();
  const amount = watch("amount");

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="label" color="text.secondary">
          Amount
        </Typography>

        <PriceInput
          value={amount}
          onChange={(e) => setValue("amount", e)}
          placeholder="Amount"
          allowNegative={true}
          maxDecimal={8}
          coinName={selectedCoin?.coinName}
          max={transferAmountMax}
          min={0}
          showPrefix={false}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Typography mr={1} variant="h5" color="text.secondary">
                  {selectedCoin?.coinName}
                </Typography>

                <AdornmentButton
                  variant="text"
                  color="secondary"
                  onClick={() => setValue("amount", transferAmountMax)}
                >
                  Max
                </AdornmentButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography component="span" color="text.secondary" variant="h5">
          Available Balance:

          <Typography component="span" variant="h5" color="text.main">
            {" "}<NumberFormats value={transferAmountMax} />{" "}
          </Typography>

          {selectedCoin?.name}
        </Typography>
      </Grid>
    </>
  );
}

export default TransferAmount;
